/* eslint-disable max-len, max-lines */
import {getContent, getPatchNote, PatchNote, PatchNoteContent, PatchNoteType} from './UIPatchNoteModule'

export class PatchNoteData {
    protected readonly patchNotes: PatchNote[]
    protected readonly announcement: string[]

    constructor() {
        this.patchNotes = []
        this.announcement = []

        // this.announcement.push('<b>JOIN THIS WEEKEND\'S 4P TOURNAMENT!!! <a href="https://docs.google.com/forms/d/1rqv-nuJhT5bx1AkuAgrous93NKQNNZ3AnMdwS5iZ2Vc" target="_blank">REGISTER HERE</a></b>')
        // this.announcement.push('<a href="https://docs.google.com/forms/d/1rqv-nuJhT5bx1AkuAgrous93NKQNNZ3AnMdwS5iZ2Vc" target="_blank"><img src="/dist/images/announcement_colonist_tournament.png?rev=" style="width: 100%"></a>')
        // this.announcement.push('<a href="https://www.youtube.com/@colonistio/?sub_confirmation=1" target="_blank"><img src="/dist/images/announcement_colonist_con_24.png" style="width: 100%"></a>')
        // this.announcement.push('Check out our latest video! </b><a href="https://youtu.be/R_hl_CAefrg" target="_blank">1 v 1 Guide!</a>!</b>')
        // this.announcement.push('<iframe style="display: block; margin: 0 auto;" width="560" height="315" src="https://www.youtube.com/embed/xtkDDYhfMHw?si=CugURvk5342Fyj02" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>')
        // this.announcement.push('<b>We are looking for a Community Manager. Check out <a href="/careers" target="_blank">careers</a>!</b>')
        // this.announcement.push('<a href="https://blog.colonist.io/colonist-io-2023-summary/"><img src="/dist/images/announcement_2023yearlystats.png" style="width: 100%"></a>')
        // this.announcement.push('<a href="/store#gift"><img src="/dist/images/announcement_gift.png" style="width: 100%"></a>')

        // Jeff

        // Andre

        // Rob

        // Devyesh

        // Oguz

        // Stan

        // Muhammad

        // Marc

        // Dang

        // ! PUBLIC PN FORMAT: vxxx.push(getContent(PatchNoteType.xxx, 'Description', ['Thanks to'], 'Before .png', 'After .png', ['FeatureUpvote link']))

        const v251: PatchNoteContent[] = []
        v251.push(getContent(PatchNoteType.Update, 'Players who quit now have 100 seconds to rejoin before the game ends automatically'))
        v251.push(getContent(PatchNoteType.Fix, '[Discord] Fixed invite online friends button not working'))

        // Rob
        // Rename discord classes and variables

        // Devyesh
        // [Mobile] Bumps @babel/runtime from 7.26.9 to 7.27.0.
        // [Mobile] Fixing app related issues
        // [Mobile] Android full screen mode fixed
        // [Mobile] Added landscape mode is deprecated popup. Also removes toggle for new players

        // Marc
        // Catch error when sending DM 24h after last activity launch and ignore if user cannot receive messages

        this.patchNotes.push(getPatchNote(2025, 5, 6, 251, v251))

        const v250: PatchNoteContent[] = []
        v250.push(getContent(PatchNoteType.Update, 'Add friends from the room', undefined, undefined, 'https://imgur.com/a/JmLOT3I'))
        v250.push(getContent(PatchNoteType.Update, 'Redesigned top notification banners', undefined, 'https://imgur.com/a/T4ocWXF', 'https://imgur.com/a/ujkJ8Ov'))

        // Devyesh
        // [Mobile] Migrate apple users from old account to new account

        // Muhammad
        // cleanup console logs in prod & dev
        // web and discord default rooms settings now the same (except discord is private and karma inactive)
        // v250.push(getContent(PatchNoteType.Update, '[Mobile] Improved store sidebar style', undefined, 'https://imgur.com/a/DP7uZMm', 'https://imgur.com/a/vOeAOKC'))

        // Marc
        // New popup when returning to homepage at the end of a game to promote the rewards program
        // New Lobby Ad to promote the rewards program

        this.patchNotes.push(getPatchNote(2025, 4, 29, 250, v250))

        const v249: PatchNoteContent[] = []
        v249.push(getContent(PatchNoteType.Update, 'Chat box can now be minimized', undefined, undefined, 'https://imgur.com/a/H01N6bs'))
        v249.push(getContent(PatchNoteType.Update, '[Discord Activity] You can now view your friends\' profiles', undefined, undefined, 'https://imgur.com/a/N3C59de'))
        v249.push(getContent(PatchNoteType.Fix, 'Fixed sending repetitive \'Action taken\' report notifications'))
        v249.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed leaderboard tabs scrolling', undefined, 'https://imgur.com/a/nStswhs', 'https://imgur.com/a/7zrxm9v'))

        // Oguz
        // Improved strikethrough price style in store page yearly membership cards

        // Muhammad
        // fix tourney register link not working on discord
        // remove tshirt survey ad

        // Marc
        // Update Rewards Program text
        // Fix referral bugs (https://github.com/colonistio/katan/pull/19355#issuecomment-2810779261)

        // Dang
        // Build React End game screen and remove old canvas End game screen
        // Fix Game log and Game chat sizing in mobile landscape
        // Fix UI game position resizing
        // Fix Discord Avatar alignment in Game Chat
        // Fix missing avatar in Game Feed Log

        this.patchNotes.push(getPatchNote(2025, 4, 22, 249, v249))

        const v248: PatchNoteContent[] = []
        v248.push(getContent(PatchNoteType.Feature, '[Discord Activity] Automatically join your activity\'s room when you load the game'))
        v248.push(getContent(PatchNoteType.Fix, 'Fixed lobby ads overlapping with notification panel', undefined, 'https://imgur.com/a/SW7w5tC', 'https://imgur.com/a/pE1WGUI'))
        v248.push(getContent(PatchNoteType.Fix, 'Fixed leaderboard search bar on smaller screens', undefined, 'https://imgur.com/a/Pig2CUn', 'https://imgur.com/a/HCGbpcV'))

        // Rob
        // Remove 1v1 Easy Bot A/B Test; Beginner Mode is default
        // Added beginner hints to web for users with fewer than 2 completed games
        // Hide beginner mode for users with 2+ completed games
        // Removed unused beginner stuff

        // Devyesh
        // [Mobile] Hide status bar on mobile

        // Oguz
        // Improved username moderation: Perspective API now checks for bad words in usernames
        // Stopped tracking [first game analytics, hover action usages, profile page section visits, game statistics, player game statistics, player game turn statistics] to free up space in the database

        // Muhammad
        // fix discord mobile not opening because of gift icon
        // fix ads overlapping notification panel
        // fix duplicate change username popup when clicking info icon in room

        // Marc
        // AB test sending a DM 24h after last activity launch to reactive discord players
        // Remove AB Test that inverts the main CTA on Discord and rename it to "Play with Friends", it is now default

        this.patchNotes.push(getPatchNote(2025, 4, 15, 248, v248))

        const v247: PatchNoteContent[] = []
        v247.push(getContent(PatchNoteType.Update, 'Refreshed the site\'s background color', undefined, 'https://imgur.com/a/9pyZav3', 'https://imgur.com/a/m8Nr3p6'))
        v247.push(getContent(PatchNoteType.Fix, 'End game screen progress bar animation speed now depends on the winning action'))
        v247.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fixed store gift avatar text link not opening the gift overlay'))

        // Jeff
        // Disable AFK kick timer for private games

        // Rob
        // Remove 1v1 Easy Bot A/B Test; Beginner Mode is default
        // v248.push(getContent(PatchNoteType.Feature, 'Automatically reconnect to your game if disconnected'))

        // Devyesh
        // [Mobile] Update logo in mobile app
        // [Mobile] Fix hover color when button is disabled
        // [Mobile] Let app reconnect even if hidden on mobile device
        // [Mobile] Show notification popup when homepage is loaded instead of when game started

        // Oguz
        // Fixed bots trading with opponents in tournaments

        // Muhammad
        // add country flag to discord ranked games if they've updated their region
        // add gift icon to mobile store
        // v247.push(getContent(PatchNoteType.Update, 'Improved tooltip accessibility across the site', undefined, 'https://imgur.com/a/B5RF17I', 'https://imgur.com/a/6cMBe7Z'))

        // Marc
        // Add the Referral Program to the store page
        // Add a new AB test that inverts the main CTA on Discord and rename it to "Play with Friends"

        this.patchNotes.push(getPatchNote(2025, 4, 8, 247, v247))

        const v246: PatchNoteContent[] = []
        v246.push(getContent(PatchNoteType.Update, '1v1 lobby games will award the win after a player quits'))
        v246.push(getContent(PatchNoteType.Update, 'Hide Rematch button from spectators'))
        v246.push(getContent(PatchNoteType.Update, 'Prevent accidental turn skipping by pressing spacebar right after the turn starts'))
        v246.push(getContent(PatchNoteType.Fix, 'Fixed online players displaying a bot avatar during the game'))
        v246.push(getContent(PatchNoteType.Fix, 'Fixed room color selector overlapping with the player name'))

        // Devyesh
        // [Mobile] Update mobile version api with approval build version number
        // [Mobile] Fix the enlarged color image in store popup
        // [Mobile] Fix positioning of the trophy icon in CnK games
        // [Mobile] Fix leaderboard UI
        // [Mobile] Fixing white space in new mobile app and migrating to new ios account

        // Oguz
        // Move Gifting overlay A/B test to store page.
        // Added A/B Test - GIFTING_CHANGE_BEST_VALUE_HINT

        // Muhammad
        // add colonist marks to press kit
        // remove colonist marks from press kit
        // billed monthly -> billed monthly, cancel anytime
        // new homepage ad for tshirt survey

        // Marc
        // Remove AB Test animation of the Invite Friends button on Discord: always animate the button
        // Remove completely Catan Masterpiece Series Ads
        // AB Test Referral Programs

        this.patchNotes.push(getPatchNote(2025, 4, 1, 246, v246))

        const v245: PatchNoteContent[] = []
        v245.push(getContent(PatchNoteType.Fix, '[Mobile] Fix Create Room button getting cut off in some devices', undefined, 'https://i.imgur.com/jtE4vHH.png', 'https://i.imgur.com/DY70YPI.png'))

        // Devyesh
        // [Mobile] Do not show beginner mode button if user has completed 2 games
        // Added /removefeaturevalue command to remove feature values, in case accident added

        // Andrew
        // Replaced the PNG for the Easter ad

        this.patchNotes.push(getPatchNote(2025, 3, 25, 245, v245))

        const v244: PatchNoteContent[] = []
        v244.push(getContent(PatchNoteType.Update, 'Added Easy, Medium, and Hard bot games for web', undefined, undefined, 'https://imgur.com/2sfYVbH'))
        v244.push(getContent(PatchNoteType.Update, 'Room containers take the whole screen on large screens', undefined, 'https://imgur.com/a/DAhKhQS', 'https://imgur.com/a/7UE8Or2'))
        v244.push(getContent(PatchNoteType.Fix, '[Mobile] Hide settings button in replay and game over screen', undefined, 'https://i.imgur.com/KQCzDQ6.png', 'https://i.imgur.com/IhKgY5v.png'))

        // Rob
        // Clear DOM on game load
        // Discord uses same default power and resolution settings as web
        // Discord end game placement text same as web
        // AB Test 1v1 Easy Bots instead of Beginner Mode
        // Remove AB Test PRIVATE_ROOM_BY_DEFAULT

        // Devyesh
        // [Mobile] Ported cloudflare turnstile to mobile
        // [Mobile] Added banner ads support on matchmaking screen
        // [Mobile] Remove landscape vs portrait selection popup
        // [Mobile] Do not show beginner mode button if user has completed 2 games
        // [Mobile] Added push notification popup at high intent locations
        // [Mobile] Show update app popup if user is using an old version of the app

        // Oguz
        // Added creation and removal of multiple tournament room keywords
        // Updated mobile store membership card styles
        // Implemented Mute Punishment Table and replaced all User.mutedUntil usages with it

        // Muhammad
        // player hover animations in lobby reflect the player's click action
        // fix no scrolling on mobile

        // Marc
        // Remove prepopup before showing the actual popup to share the activity on Discord
        // Store Discord channel type in the database

        this.patchNotes.push(getPatchNote(2025, 3, 18, 244, v244))

        const v243: PatchNoteContent[] = []
        v243.push(getContent(PatchNoteType.Update, 'Improved notification panel interface on hover', undefined, 'https://imgur.com/B2RLbz1', 'https://imgur.com/cL5THJi'))
        v243.push(getContent(PatchNoteType.Update, '[Discord Activity] Can gift to others at end-game screen, or during a game', undefined, undefined, 'https://imgur.com/Bd7E9kb'))
        v243.push(getContent(PatchNoteType.Update, 'Prevent bots from spamming useless trades'))

        // Devyesh
        // [Mobile] Implements AB test for push notification popup v2

        // Muhammad
        // [discord] gift users in game and in endgame
        // [mobile] gift users in endgame
        // complete small discord feature gaps

        // Marc
        // Add a pre-popup before showing the actual popup to share the activity on Discord
        // AB Test to animate the invite friends button inside a room on Discord to draw attention

        this.patchNotes.push(getPatchNote(2025, 3, 11, 243, v243))

        const v242: PatchNoteContent[] = []
        v242.push(getContent(PatchNoteType.Update, '[Discord] Can now gift to others', undefined, undefined, 'https://imgur.com/a/s5RRc2b'))
        v242.push(getContent(PatchNoteType.Update, '[Mobile] Added No Troll mode'))
        v242.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed chat not being visible when game ends'))
        v242.push(getContent(PatchNoteType.Fix, 'Prevent tab blinking in bot games'))

        // Devyesh
        // [Mobile] Merge web and mobile store membership pages
        // [Mobile] Fixing external url bug in mobile app
        // [Mobile] Added no troll mode in mobile

        // Oguz
        // Prevent auto trade rejection countdown in tournament rooms
        // Fixed edge case where easy bot can't place robber

        // Stan
        // Fix muted players being able to send chat messages in games
        // Change auto-mute behavior: Mute after 3 reports in 7 days, shadow mute instead of the default mute behavior.

        // Muhammad
        // fix patch note winner link and overview page on discord mobile

        // Marc
        // Fix Invite Friends button container still showing when button is hidden
        // Add popup to share the activity on Discord when returning to homepage after game ends

        this.patchNotes.push(getPatchNote(2025, 3, 4, 242, v242))

        const v241: PatchNoteContent[] = []
        v241.push(getContent(PatchNoteType.Update, 'Added keyboard shortcuts to Replay', undefined, undefined, 'https://www.loom.com/share/c1bcf4c2c0ff47c2ac0b297852ae4833?sid=1b625472-c2d9-405e-a411-2c5e9168642e'))
        v241.push(getContent(PatchNoteType.Update, 'Added animations and sounds to Replay'))
        v241.push(getContent(PatchNoteType.Fix, 'Fixed shore tile overlap'))
        v241.push(getContent(PatchNoteType.Fix, 'Fixed tooltip overlapping with replay controllers'))

        // Jeff
        // Replay bug: fixed slider not syncing with button index

        // Devyesh
        // [Mobile] Fixing external url bug in mobile app
        // [Mobile] AB test for landscape/portrait switch popup
        // [Mobile] Fixing console errors during development
        // [Mobile] Added value support for feature flags

        // Oguz
        // Removed A/B Tests YEARLY_STRIKETHROUGH_PRICE & GIFTING_MONTHLY_PRICE_FOR_YEARLY_TIERS
        // Added A/B Test GIFTING_LESS_PERKS

        // Stan
        // Fixed room setting & replay sliders outline after space bar press

        // Muhammad
        // remove youtube videos and sub button from leaderboard

        this.patchNotes.push(getPatchNote(2025, 2, 25, 241, v241))

        const v240: PatchNoteContent[] = []
        v240.push(getContent(PatchNoteType.Fix, 'Karma penalty is only given after being disconnected for 2 mins'))
        v240.push(getContent(PatchNoteType.Fix, 'Fixed displaying "Your turn" during trades'))
        v240.push(getContent(PatchNoteType.Fix, 'Fix notification panel going offscreen', undefined, 'https://imgur.com/a/iVfpNi3', 'https://imgur.com/a/loj1EmD'))
        v240.push(getContent(PatchNoteType.Fix, 'Fixed last player not being automatically awarded the win when another player disconnected in 1v1 Ranked'))

        // Rob
        // Add beginner mode to web. Hidden PN because it's a test
        // AB test private vs public rooms by default for web and mobile. Collect room usage data
        // Rebranded Online Username as Colonist Username on Discord
        // Membership and gifting tabs on Discord are annual by default
        // Landing page shown to first time Discord users. Otherwise homepage shown

        // Devyesh
        // [Mobile] Show room full message when room is full in invite friends drawer
        // [Mobile] Added push notification support. As an example, user gets push notification when it's their turn to play.
        // [Mobile] Saved room settings for the host
        // [Mobile] Implementation of push notifications on player turn ends
        // [Mobile] Added analytics for invite friends button
        // [Mobile] Added popup to request push notifications

        // Oguz
        // Added apps/game-states-analysis

        // Muhammad
        // general improvements to header styles
        // lint rule to not use window.location.href and window.open; use navigateToPage instead
        // fix paypal and xsolla portals not opening on mobile

        // Marc
        // Remove AB Test No Trolls vs. High Karma
        // Update Catan Masterpiece Series Ads
        // Add virality tracking with new table 'user_referral'
        // Add new logic to share activity via a link and track referral with it

        this.patchNotes.push(getPatchNote(2025, 2, 18, 240, v240))

        const v239: PatchNoteContent[] = []
        v239.push(getContent(PatchNoteType.Update, 'Notification panel has a refreshed look', undefined, 'https://imgur.com/aBk94HQ', 'https://imgur.com/8au1xdL'))
        v239.push(getContent(PatchNoteType.Update, 'Merchant Fleet no longer allows you to select a card you already have 2:1 rate'))
        v239.push(getContent(PatchNoteType.Update, '[Mobile] Added invite friends button to room', undefined, 'https://i.imgur.com/Tq7S6Xj.png', 'https://i.imgur.com/7ks5Cc9.png'))
        v239.push(getContent(PatchNoteType.Fix, 'Fix road icons displaying incorrectly', undefined, 'https://imgur.com/a/shuKOeQ', 'https://imgur.com/a/wHnph6X'))
        v239.push(getContent(PatchNoteType.Fix, 'Fixed some C&K actions not providing bonus time'))
        v239.push(getContent(PatchNoteType.Fix, 'Fixed card animations not working in spectator mode'))
        v239.push(getContent(PatchNoteType.Fix, '[Discord Mobile] Fixed some pages not displaying correctly', undefined, 'https://imgur.com/a/LGCvDbN.png', 'https://imgur.com/a/t75jsKU.png'))
        v239.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed dice view position on replay', undefined, 'https://i.imgur.com/TUcfwoE.png', 'https://i.imgur.com/snIhfA9.png'))

        // Jeff
        // Remove development season to make test servers behave like production

        // Devyesh
        // [Mobile] Updated join room mobile notification for room invites
        // [Mobile] Added analytics for invite friends button
        // [Mobile] Fix misclick in mobile gift friend button

        // Oguz
        // Replace store and gifting a/b tests ('GIFTING_NUMBER_OF_PAGES' -> 'GIFTING_MONTHLY_PRICE_FOR_YEARLY_TIERS', 'MEMBERSHIP_PERKS_EXPLANATION' -> 'YEARLY_STRIKETHROUGH_PRICE')
        // Auto-mute players if they are reported for chat abuse and they have sent 2 messages above 0.8 toxicity score

        // Muhammad
        // Minor style improvements on homepage
        // Added youtube videos to leaderboards page https://i.imgur.com/hdYjbGg.jpeg

        this.patchNotes.push(getPatchNote(2025, 2, 11, 239, v239))

        const v238: PatchNoteContent[] = []
        v238.push(getContent(PatchNoteType.Blog, 'Colonist 2024 Summary! <a href="https://blog.colonist.io/colonist-io-2024-summary/" target="_blank">Read here!</a>', undefined, undefined, undefined, ['https://blog.colonist.io/colonist-io-2024-summary/']))
        v238.push(getContent(PatchNoteType.Update, 'Muted players are now announced at the start of the game', undefined, undefined, 'https://i.imgur.com/8gbRJK5.png'))
        v238.push(getContent(PatchNoteType.Update, '[Discord Activity] Replays are now available from profile history page', undefined, undefined, 'https://imgur.com/a/Y42nB31'))
        v238.push(getContent(PatchNoteType.Update, '[Discord Activity] Access player profiles while playing in public games', undefined, undefined, 'https://imgur.com/a/7wYcoyk'))
        v238.push(getContent(PatchNoteType.Update, '[Discord Activity] Colonist social media links are shown in the footer', undefined, 'https://imgur.com/a/qTCh8li', 'https://imgur.com/a/5UelIuy'))
        v238.push(getContent(PatchNoteType.Update, '[Mobile] Added invite friends button to room', undefined, undefined, undefined))
        v238.push(getContent(PatchNoteType.Fix, '[Discord Activity] Friend request notifications are received when you log in'))
        v238.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed Visit Store button on end game screen'))

        // Jeff
        // Remove counter offer for trade creator

        // Rob
        // Fix discord profile replay when you're not a member

        // Devyesh
        // [Mobile] Fix vendor specific css in header

        // Oguz
        // Create PageVisit Analytic Events for entry pages in frontend
        // created command `/generategifturls`. Generates bulk gift URLs for easy distribution

        // Muhammad
        // remove use of iframecommunication; now uses sendSDKRequest()
        // refactor listener.register to use map of constructors
        // fix roads on animated map

        this.patchNotes.push(getPatchNote(2025, 2, 4, 238, v238))

        const v237: PatchNoteContent[] = []
        v237.push(getContent(PatchNoteType.Update, '[Mobile] You can now change your avatar!', undefined, undefined, 'https://i.imgur.com/DgkaEeu.png'))
        v237.push(getContent(PatchNoteType.Update, '[Mobile] Added viewing other player\'s profiles', undefined, undefined, undefined))
        v237.push(getContent(PatchNoteType.Update, 'Bank trade mode is now the default setting for 1v1 matchmaking games', undefined, undefined, 'https://i.imgur.com/YZ4k7zk.png'))
        v237.push(getContent(PatchNoteType.Update, 'Click on chat messages to view player options', undefined, undefined, 'https://imgur.com/a/pJ6Bmev'))
        v237.push(getContent(PatchNoteType.Update, 'Added notification when muting/unmuting users', undefined, undefined, 'https://imgur.com/a/n4f9qQe'))
        v237.push(getContent(PatchNoteType.Update, 'Friend request notifications are received without page refresh'))
        v237.push(getContent(PatchNoteType.Update, '[Discord Activity] Added No Trolls room option', undefined, undefined, 'https://imgur.com/a/zP7wB9T'))
        v237.push(getContent(PatchNoteType.Update, '[Discord Activity] Can add and accept friends on Discord'))
        v237.push(getContent(PatchNoteType.Fix, 'Fixed the last 5-second countdown sound not being played for the turn player', undefined, undefined, undefined))
        v237.push(getContent(PatchNoteType.Fix, 'Fixed bug where top left corner of the game was unresponsive'))
        v237.push(getContent(PatchNoteType.Fix, 'Fixed ghost Metropolis icon appearing during replay'))
        v237.push(getContent(PatchNoteType.Fix, 'Removed Metropolis animation during replay'))
        v237.push(getContent(PatchNoteType.Fix, 'Removed Merchant animation during replay'))

        // Jeff
        // Clean up code owners
        // VSCode mocha explorer now works properly

        // Devyesh
        // [Mobile] Make dice visible over chat and logs

        // Muhammad
        // fix mp4 videos taking whole screen on ios
        // fix gift overlay not showing for 50% of people

        // Marc
        // Fix bug empty recipient username works on re-accessing gifting overlay
        // display login popup on gift overlay when user is not logged in
        // AB testing No Trolls vs. High Karma name

        this.patchNotes.push(getPatchNote(2025, 1, 28, 237, v237))

        const v236: PatchNoteContent[] = []
        v236.push(getContent(PatchNoteType.Update, '[Discord Activity] Added Plus and Elite yearly Memberships'))
        v236.push(getContent(PatchNoteType.Update, '[Discord Activity] Gifting Memberships is now available!'))
        v236.push(getContent(PatchNoteType.Update, '[Discord Activity] Supports all languages web does', undefined, 'https://imgur.com/a/kB4lhvv', 'https://imgur.com/a/u6clWh8'))
        v236.push(getContent(PatchNoteType.Update, '[Discord Activity] Added Karma for public rooms', undefined, 'https://imgur.com/a/lw4esZL', 'https://imgur.com/a/GpJ8cnZ'))
        v236.push(getContent(PatchNoteType.Update, 'Removed info icon from Karma in room', undefined, 'https://imgur.com/a/4ryLWou', 'https://imgur.com/a/vJbAgQ9'))
        v236.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed dice appearing behind chat and game log in portrait mode'))
        v236.push(getContent(PatchNoteType.Fix, 'Fixed incorrect longest road count after using Deserter'))
        v236.push(getContent(PatchNoteType.Fix, 'Fixed flickering tooltips on small screens'))
        v236.push(getContent(PatchNoteType.Fix, 'Fixed ghost city wall appearing during replay'))
        v236.push(getContent(PatchNoteType.Fix, 'Fixed city wall animation during replay'))

        // Jeff
        // Fix "development" card text in CK end game screen
        // Fix initial state not returning to initial state when sliding replay slider

        // Rob
        // Rework notifications to send through lobby server
        // Fix notifications not sending until you refresh the page
        // Add A/B Test - Show Homepage on Discord
        // Allow Gifting and all membership ads on Discord
        // Add A/B Test - Show all social media links on Discord footer

        // Oguz
        // Fixed gift overlay page order on consecutive access through different access points
        // Fixed the next button position on gift tier selection page
        // Trades get auto-rejected when the player moves Colonist to the background

        // Muhammad
        // add /values, /terms, /press-kit, /refund-policy pages to discord

        this.patchNotes.push(getPatchNote(2025, 1, 21, 236, v236))

        const v235: PatchNoteContent[] = []
        v235.push(getContent(PatchNoteType.Update, 'Timer turns red when you have 5 seconds left', undefined, undefined, 'https://i.imgur.com/Um04x18.png'))
        v235.push(getContent(PatchNoteType.Update, 'Disabled City Wall sound during replay'))
        v235.push(getContent(PatchNoteType.Update, '[Discord Activity] Added profile page', undefined, 'https://imgur.com/a/PwhUQ91', 'https://imgur.com/a/Wpi6Lmp'))
        v235.push(getContent(PatchNoteType.Update, '[Discord Activity] Added Avatars'))
        v235.push(getContent(PatchNoteType.Fix, 'Fixed roads alignment on the map', undefined, 'https://i.imgur.com/pJUstbm.jpeg', 'https://i.imgur.com/8VY2Bk8.png'))
        v235.push(getContent(PatchNoteType.Fix, 'Fixed gaps between tiles on the map', undefined, 'https://i.imgur.com/tLqeD4A.png', 'https://i.imgur.com/3TwjGMa.png'))
        v235.push(getContent(PatchNoteType.Fix, 'Fixed dice appearing twice during replay'))
        v235.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed player profile not opening on the app'))

        // Jeff
        // Fix exploit that allowed players to see the order of the progress cards and dev cards in the bank.
        // Fix exploit that allowed players to see other players dev cards or progress cards.
        // Fix small bug with replay + chat + changing perspectives. 1 line fix

        // Rob
        // Save and use metadata in db when gifting on Discord
        // Coin section available on Discord mobile

        // Devyesh
        // [Mobile] Merging Profile > friends section in web and mobile
        // [Mobile] Force refresh client when new version is available (to break the cache)
        // [Mobile] Fixing singleton page horizontal scroll
        // [Mobile] Fix translation on app reload
        // [Mobile] Fix multiple friend requests being shown for same user
        // [Mobile] Fixing replay url not working

        // Oguz
        // All gift purchases now exist in gift_membership table
        // Fixed item deletion transaction type on gift membership activation
        // Force-enabled Flicker, Shake and Cooldown animations for the players who set animations as disabled in settings
        // Add A/B Test - Merge Maps and Expansions Description in Store Membership Cards
        // Fixed sentry error caused by browser tab blinking

        // Muhammad
        // rename corner popup to corner notification; classes and classnames/styles
        // fix discord redirect to web popup not working on profile settings page
        // Added new resources for <a href="/press-kit#content_creation">content creators</a>

        // Marc
        // Add Avatars on Discord

        // Dang
        // Update Return To Map text

        this.patchNotes.push(getPatchNote(2025, 1, 14, 235, v235))
    }

    getContributionCount(username: string): number {
        let count = 0
        for(const pn of this.getAll()) {
            for(const content of pn.contents) {
                for(const contributor of content.contributors) {
                    if(contributor == username) count += 1
                }
            }
        }
        return count
    }

    getAnnouncements(): string[] {
        return this.announcement
    }

    getAll(): PatchNote[] {
        return this.patchNotes
    }

    getLast5(): PatchNote[] {
        return this.patchNotes.slice(0, 5)
    }

    getLatest(): PatchNote[] {
        return this.patchNotes.slice(0, 1)
    }
}
